import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
} from '@angular/core';
import { AvatarComponent } from '@ui/avatar/avatar.component';
import { AVATAR_VARIANT_ORDER, AVATAR_VARIANT } from '@ui/utils/constants';

export interface AvatarStackItem {
	src?: string;
	tooltipText?: string;
	initials: string;
	id: string;
}

@Component({
	selector: 'ui-avatar-stack',
	standalone: true,
	imports: [AvatarComponent, CommonModule],
	templateUrl: './avatar-stack.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarStackComponent {
	size = input<'sm' | 'md' | 'lg'>('md');
	avatars = input<AvatarStackItem[]>([]);
	maximumAvatars = input<number>(6);

	remainingAvatars = computed(() => {
		const avatars = this.avatars();
		const maximumAvatars = this.maximumAvatars();
		return avatars.slice(maximumAvatars);
	});

	remainingTooltips = computed(() => {
		return this.remainingAvatars()
			.map((a) => a.tooltipText)
			.join(' \n ');
	});

	excessAvatar = computed<AvatarStackItem | null>(() => {
		const remainingAvatarCount = this.remainingAvatars().length;
		if (remainingAvatarCount === 0) return null;
		return {
			initials: remainingAvatarCount <= 9 ? `+${remainingAvatarCount}` : '9+',
			id: 'excess',
			variant: AVATAR_VARIANT.Default,
			tooltipText: this.remainingTooltips(),
		};
	});

	listItemClasses = computed(() => [
		this.commonListItemClasses,
		this.getSizeClasses(),
	]);

	private getSizeClasses() {
		return this.size() === 'sm' ? '-ml-1.5' : '-ml-2';
	}

	private commonListItemClasses =
		'flex list-none border-2 border-white rounded-full';

	public variantOrderList = AVATAR_VARIANT_ORDER;
}
